module.exports = __webpack_public_path__ + "img/api-consultancy-step.656e0fdd.svg";